import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.index-of.js";
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue';
export default {
  name: 'sideIcon',
  data: function data() {
    return {
      animationBar: 'side-bar-begin',
      inMaoyanTab: false
    };
  },
  components: {},
  props: {
    sideIcon: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    originPageScrollTop: {
      type: Number
    },
    pageScrollTop: {
      type: Number
    }
  },
  created: function created() {
    var _this = this;
    setTimeout(function () {
      if (_this.animationBar === 'side-bar-begin') {
        _this.animationBar = 'hide-side-bar';
        setTimeout(function () {
          _this.animationBar = '';
        }, 1000);
      }
    }, 3000);
    if (location.href.indexOf('maoyantab') > -1) {
      this.inMaoyanTab = true;
    }
  },
  watch: {
    pageScrollTop: function pageScrollTop(val) {
      var _this2 = this;
      var old = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.originPageScrollTop;
      var animationBar = this.animationBar;
      if (val < old && !animationBar) {
        this.animationBar = 'show-side-bar';
        this.sideBarLoop = setTimeout(function () {
          _this2.animationBar = '';
        }, 5000);
      } else if (val > old && (animationBar === 'show-side-bar' || animationBar === 'side-bar-begin')) {
        this.animationBar = 'hide-side-bar';
        clearTimeout(this.sideBarLoop);
        setTimeout(function () {
          _this2.animationBar = '';
        }, 1000);
      }
    }
  },
  methods: {
    go: function go(link) {
      this.goAdPage(link);
    }
  }
};